import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

class Msg extends Component {
    render() {
        if (this.props.asTitle) {
            return <>{this.props.intl.formatMessage({ id: this.props.id }, this.props.values)}</>
        }
        return <FormattedMessage {...this.props} />
    }
}

export default injectIntl(Msg)
